<template>
  <div>
    <h1 class="center">INSTRUCTORES</h1>
    <h3 class="center">Gestion de instructores</h3>
    <v-container style="">
      <div :style="{ width: !$vuetify.breakpoint.smAndDown ? '70%' : '100%' }">
        <v-btn :color="$ajustes.colorCabecera" style="color: white;" @click="nuevoInstructor = true; formularioDialogo = true">NUEVO
          INSTRUCTOR</v-btn>
        <v-btn class="ml-3" :color="$ajustes.colorCabecera" style="color: white;"
          @click="obtenerInstructores()"><v-icon>mdi-refresh</v-icon></v-btn>
      </div>
      <br>
            <v-card elevation="0" class="pa-1 pl-4 mb-1" :style="{ border: '1px solid ' + $ajustes.colorCabecera }"
        v-for="instrutor in instrutores" :key="instrutor.id">
        <div style="display: flex;">
          <h3 style="text-align: left;">Fecha inicio: <span style="font-weight: normal;"> {{ instrutor.fecha_inicio
          }}</span></h3>
          <v-spacer></v-spacer>
          <div style="float: right;">
            <span class="ma-1 pointer" :style="{ fontWeight: instrutor.destacado == 1 ? 'bold' : null }"
              @click="estadoInstructor(instrutor.id, 'destacado', instrutor.destacado == 0 ? 1 : 0)">DESTACADO</span>
            <span class="ma-1 pointer" :style="{ fontWeight: instrutor.habilitado == 1 ? 'bold' : null }"
              @click="estadoInstructor(instrutor.id, 'habilitado', instrutor.habilitado == 0 ? 1 : 0)">HABILITADO</span>
            <span class="ma-1 pointer" @click="instrutorDatos = instrutor; visualizarDialogo = true">VER</span>
            <span class="ma-1 pointer"
              @click="nuevoInstructor = false; instrutorDatos = instrutor; formularioDialogo = true">EDITAR</span>
            <span class="ma-1 pointer" @click="eliminarInstructor(instrutor.id)">ELIMINAR</span>
          </div>
        </div>
        <h2 style="text-align: left;"><v-icon v-if="instrutor.destacado == 1" class="mb-1 r-3" color="gold" small>mdi-star-circle</v-icon>{{ instrutor.rol }} | {{ instrutor.nombres }}
        </h2>
      </v-card>
    </v-container>
    <formulario :propCrear="axios.crearInstructor" :propActualizar="axios.actualizarInstructor" :propNuevo="nuevoInstructor"
      :propInstructor="instrutorDatos" :propDialogo="formularioDialogo"
      @closeDialogo=" obtenerInstructores(); formularioDialogo = false" />
    <visualizar :propInstructor="instrutorDatos" :propDialogo="visualizarDialogo" @closeDialogo="visualizarDialogo = false" />
  </div>
</template>
<script>
import * as axios from "./axios";
import formulario from "./formulario";
import visualizar from "./visualizar";

export default {
  components: {
    formulario,
    visualizar
  },
  data() {
    return {
      formularioDialogo: false,
      visualizarDialogo: false,
      nuevoInstructor: true,
      instrutorDatos: {},
      instrutores: [],
      axios
    };
  },
  mounted() {
    this.obtenerInstructores()
  },

  created() { },
  computed: {},
  methods: {
    async obtenerInstructores() {
      this.instrutores = []
      var response = await axios.obtenerInstructores()
      this.instrutores = response.data
    },
    async estadoInstructor(_id, _campo, _estado) {
      const instrutor = {
        id: _id,
        campo: _campo,
        estado: _estado,
      }
      await axios.estadoInstructor(instrutor)
      this.obtenerInstructores()
    },
    async eliminarInstructor(instrutorId) {
      await axios.eliminarInstructor(instrutorId)
      this.obtenerInstructores()
    },
    continuar() { },
    close() { },
  },
};
</script>
<style scoped>
.fullSize {
  margin: 0;
  padding: 0;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #f0f0f0;
  overflow: hidden;
  /* Cambia la fuente a Roboto */
}

.logo {
  width: 120px;
  height: 160px;
  background-color: #333;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.splash-text {
  font-size: 36px;
  font-weight: bold;
  color: transparent;
  text-align: center;
  animation: splashAnimation 2s ease-in-out forwards;
  opacity: 0;
}

.subtitle {
  font-size: 24px;
  color: #666;
  text-align: center;
  opacity: 0;
  animation: animation 2s ease-in-out forwards;
  animation-delay: 1s;
}

.loading-icon {
  opacity: 0;
  animation: animation 2s ease-in-out forwards;
  animation-delay: 2s;
}

@keyframes splashAnimation {
  0% {
    transform: scale(0.5);
    opacity: 0;
    color: transparent;
  }

  100% {
    transform: scale(1);
    opacity: 1;
    color: #333;
  }
}

@keyframes animation {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}
</style>
